module.exports = __webpack_public_path__ + "img/windwalker.30cff98e.jpg";